// extracted by mini-css-extract-plugin
export default {"container":"KPITilesSection_container__t6VOZ","title":"KPITilesSection_title__HJN-D","list":"KPITilesSection_list__mo0ur"};